module.exports = __webpack_public_path__ + "static/fipcpurplefloralrab2-7ceb091b2f73dc3cbf00583e9e846976.jpeg";